import { ILogger } from './logger.types';

export class LoggerService implements ILogger {
  private static instance: LoggerService | undefined;

  private constructor(
    public readonly name: string,
    public readonly loggers: ILogger[]
  ) {}

  public static createInstance(loggers: ILogger[]): LoggerService {
    if (LoggerService.instance) {
      throw new Error('LoggerService already initialized');
    }

    LoggerService.instance = new LoggerService('LoggerService', loggers);
    return LoggerService.instance;
  }

  public static getInstance(): LoggerService {
    if (!LoggerService.instance) {
      throw new Error('LoggerService not initialized');
    }

    return LoggerService.instance;
  }

  public static getOrCreateInstance(loggers: ILogger[]): LoggerService {
    if (LoggerService.instance) {
      return LoggerService.instance;
    }

    LoggerService.instance = new LoggerService('LoggerService', loggers);
    return LoggerService.instance;
  }

  // This is used to reset the instance to a new set of loggers
  public static resetInstance(loggers: ILogger[]): LoggerService {
    LoggerService.instance = new LoggerService('LoggerService', loggers);
    return LoggerService.instance;
  }

  public createNamedLogger(name: string): ILogger {
    const loggers = this.loggers.map((logger) =>
      logger.createNamedLogger(name)
    );
    return new LoggerService(name, loggers);
  }

  public setProjectContext(project?: {
    id: string;
    name: string;
    location: string;
  }): void {
    this.loggers.forEach((logger) => logger.setProjectContext(project));
  }

  public debug(message: string, context?: object, error?: Error): void {
    this.loggers.forEach((logger) => logger.debug(message, context, error));
  }

  public info(message: string, context?: object, error?: Error): void {
    this.loggers.forEach((logger) => logger.info(message, context, error));
  }

  public warn(message: string, context?: object, error?: Error): void {
    this.loggers.forEach((logger) => logger.warn(message, context, error));
  }

  public error(message: string, context?: object, error?: Error): void {
    this.loggers.forEach((logger) => logger.error(message, context, error));
  }
}
